import {
    Drawer,
    DrawerBody,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
    Button,
    Stack,
    Text,
    Image
  } from '@chakra-ui/react'
import { useContext } from 'react';

import { Link as ScrollLink } from 'react-scroll';
import { ColorContext } from '../Context/ColorContext';

  const Navbar_options = [{text : 'Home', id : 'home'}, {text : 'About', id : 'about'}, {text : 'Skills' , id : 'skills'}, {text : 'Projects', id : 'projects'},{text : 'Contact', id : 'contact'}];




export function NavDrawer({ isOpen, onOpen, onClose }) {
  const {colors,setColors} = useContext(ColorContext)
  let a = "<BHARAT />"

   
    return (
      <>
       
        <Drawer
          isOpen={isOpen}
          placement='left'
          onClose={onClose}
          display = {{base : 'block','836px' : 'none'}}
        
        >
          <DrawerOverlay display = {{base : 'block','836px' : 'none'}} />
          <DrawerContent display = {{base : 'block','836px' : 'none'}} bg = {colors} color = 'white'>
            <DrawerCloseButton _hover = {{background : {colors}}} />
            <DrawerHeader>{<Text fontSize={"25px"} fontWeight={"600"}>{a}</Text>}</DrawerHeader>
  
            <DrawerBody>
              {/* <Input placeholder='Type here...' /> */}
                
              
                <Stack spacing = '20px'>

                                {Navbar_options.map((el) => {


                    return <ScrollLink key = {Math.random()} to={el.id} smooth={true} duration={300}>
                    
                    


                            <Text _hover = {{cursor : 'pointer',color : 'black', borderBottom : '2px solid' , borderColor : 'black'}} px = '2' py = '1' fontWeight={600}>{el.text}</Text>
                        

                    
                    
                    
                    </ScrollLink>



                    })}

            </Stack>


            </DrawerBody>
  
           
          </DrawerContent>
        </Drawer>
      </>
    )
  }